<div class="widget-body border-box border-lighter-gray roi-widget background-white col-xs-12">
  <div class="feature-image-left"></div>
  <div class="content">
    <div>
      <h2 class="color-gray">Show your customers how much they could save</h2>
      <button class="btn background-green no-radius color-white" (click)="goToPage('/roi-calculator')">Savings calculator</button>
    </div>
  </div>
</div>
